import ApplicationV1Adapter from 'uplisting-frontend/adapters/application-v1';

export default class PhotoAdapter extends ApplicationV1Adapter {
  urlForQuery(): string {
    return `${this.host}/v2/photos`;
  }
}

declare module 'ember-data/types/registries/adapter' {
  interface AdapterRegistry {
    photo: PhotoAdapter;
  }
}
